module.exports = __webpack_public_path__ + "img/bfb8db5.png";